import React from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";
import { FaLinkedin, FaTelegramPlane } from "react-icons/fa";
import logmann2 from "../assets/logmann2.png";

const Footer = () => {
  return (
    <footer className="bg-[#ad6a51] text-[#EFD770] p-8 w-full">
      <div className="mx-auto">
        <div className="flex flex-col md:flex-row justify-around items-center space-y-4 md:space-y-0 md:space-x-8">
          <div className="mb-4 md:mb-0 overflow-hidden">
            <img
              src={logmann2}
              alt="Logo do Footer"
              className="w-56 h-56 object-contain"
            />
          </div>
          <div className="text-center md:text-left md:w-1/3 flex flex-col">
            <h2 className="text-lg font-bold mb-2">Entre em Contato</h2>
            <p>
              <FaMapMarkerAlt className="inline mr-2" />
              Avenida Assis Brasil 418, Porto Alegre/RS
            </p>
            <p>
              <FaPhone className="inline mr-2" />
              Telefone: (51) 995404199
            </p>
            <p>
              <FaEnvelope className="inline mr-2" />
              Email: manniknatasha@gmail.com
            </p>
            <a
              href="https://www.linkedin.com/in/natasha-manni-krunitzki/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EFD770] hover:text-[#00df9a] transition duration-300"
            >
              <FaLinkedin className="inline mr-2" />
              LinkedIn
            </a>
            <a
              href="http://t.me/NatashaManni"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EFD770] hover:text-[#00df9a] transition duration-300"
            >
              <FaTelegramPlane className="inline mr-2" />
              Telegram
            </a>
            <a
              href="https://wa.me/5551995404199"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EFD770] hover:text-[#00df9a] transition duration-300"
            >
              <FaWhatsapp className="inline mr-2" />
              Whatsapp
            </a>
          </div>
          <div className="w-full md:w-1/3">
            <iframe
              title="Google Maps"
              class="w-full h-96 rounded-md"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6910.058818914549!2d-51.18252371605047!3d-30.007311915100765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951979df1b5312b9%3A0x347aaa0e23d22cb4!2sAv.%20Assis%20Brasil%2C%20418%20-%20Passo%20d&#39;Areia%2C%20Porto%20Alegre%20-%20RS%2C%2091010-000!5e0!3m2!1spt-BR!2sbr!4v1739490509221!5m2!1spt-BR!2sbr"
              allowfullscreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
